import { render, staticRenderFns } from "./PingerModuleIpCard.vue?vue&type=template&id=2b56ae5c&scoped=true&"
import script from "./PingerModuleIpCard.vue?vue&type=script&lang=ts&"
export * from "./PingerModuleIpCard.vue?vue&type=script&lang=ts&"
import style0 from "./PingerModuleIpCard.vue?vue&type=style&index=0&id=2b56ae5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56ae5c",
  null
  
)

export default component.exports